import { MosState } from "src/features/mos/types";

export const getMosItems = (state: MosState) => state.items;

export const getMosLineupId = (state: MosState) => state.lineupId;

export const getMosLoading = (state: MosState) => state.loading;

export const getMosError = (state: MosState) => state.error;
